import React, { useEffect } from 'react'
import { Grid, Box, Typography, IconButton } from '@mui/material'
// import { AppLogoIcon } from '../../../components/Icons'
import ForgotPasswordForm from './ForgotPasswordForm'
import SquareLogo from '../../../assets/images/Lawtech icon square.png'
import { useNavigate } from 'react-router-dom'

const ForgotPasswordIndex = () => {
  const navigate = useNavigate()

  useEffect(() => {
    document.title = 'Forgot Password - Lawttorney'
  }, [])

  return (
    <Grid
      item
      xs={12}
      md={7}
      sx={{ overflowY: { xs: 'hidden', sm: 'auto' }, height: { xs: 'auto', sm: '100dvh' } }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            width: '100%',
            maxWidth: 560,
            minHeight: 419,
            gap: 4,
            ml: { xs: 0, sm: 10.5 },
            p: { xs: 3, sm: 0 },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'center', sm: 'flex-start' },
              width: '100%',
            }}
          >
            {/* <AppLogoIcon sx={{ width: 91, height: 63 }} /> */}
            <IconButton
              sx={{ cursor: 'pointer', marginLeft: { xs: 0, sm: '-15px' } }}
              onClick={() => {
                navigate('/auth/login')
              }}
            >
              <img src={SquareLogo} alt='' height='60px' />
            </IconButton>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: { xs: 'center', sm: 'flex-start' },
              }}
            >
              <Typography variant='h3'>Forgot Password?</Typography>
              <Typography variant='body1' sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                Please enter your registered Email address to receive a password reset link
              </Typography>
            </Box>
          </Box>
          <Box sx={{ width: '100%' }}>
            <ForgotPasswordForm />
          </Box>
        </Box>
      </Box>
    </Grid>
  )
}

export default ForgotPasswordIndex
